export const calculateFees = (value: number) => {
    const fees = value * 0.06;
    return fees;
};